import React from "react";

import WayFadeUp from "../components/transitions/WayFadeUp";
import "../css/Image-text.css";

import { PrismicImage } from "../components/common/prismicUtils";

const ImageText = ({ input, color }) => {
  const {
    image,
    text,
    title,
    horizontal_text_position,
    vertical_text_postion,
  } = input.primary;
  return (
    <WayFadeUp>
      <div
        id={input.id}
        className={`mt5 mb4 mt6-l mb6-l pl4 pr4 pl5-l pr5-l image-text flex-l mw9 center justify-between text-${horizontal_text_position} text-${vertical_text_postion}`}
      >
        {image.fluid && (
          <div
            className={`w-100 w-50-l img ${
              image?.fluid?.aspectRatio < 1 ? "portrait" : "landscape"
            }`}
          >
            <PrismicImage {...image.fluid} className="w-100 h-auto" />
          </div>
        )}
        <div className="w-100 w-40-l text">
          {title.text && (
            <h2
              className="f2 lh-copy measure tiempos mt3 mb0 mt0-l"
              style={{ color: `${color}` }}
            >
              {title.text}
            </h2>
          )}
          <div
            dangerouslySetInnerHTML={{ __html: text.html }}
            className="f4 lh-copy grey"
          />
        </div>
      </div>
    </WayFadeUp>
  );
};

export default ImageText;
